import { useId } from 'react';
import { cn } from '../../utils/cn';
import type { FormFieldProps } from './Form.types';

export function FormField({
  label,
  htmlFor: externalFor,
  error,
  helperText,
  required = false,
  children,
  className,
}: FormFieldProps) {
  const generatedId = useId();
  const htmlFor = externalFor ?? generatedId;
  const errorId = `${htmlFor}-error`;
  const helperId = `${htmlFor}-helper`;

  return (
    <div className={cn('w-full', className)}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="mb-1.5 block text-sm font-medium text-neutral-700 dark:text-neutral-300"
        >
          {label}
          {required && (
            <span className="text-error-500 ml-0.5" aria-hidden="true">
              *
            </span>
          )}
        </label>
      )}
      {children}
      {error && (
        <p id={errorId} className="text-error-600 mt-1.5 text-sm" role="alert">
          {error}
        </p>
      )}
      {helperText && !error && (
        <p
          id={helperId}
          className="mt-1.5 text-sm text-neutral-500 dark:text-neutral-400"
        >
          {helperText}
        </p>
      )}
    </div>
  );
}
